export default __webpack_public_path__ + "static/media/property_376.3997a6e9.png";